import { insertBreakTodoList } from './insertBreakTodoList';

export const withTodoList = (
  editor,
  { options },
) => {
  const { insertBreak } = editor;

  editor.insertBreak = () => {
    if (insertBreakTodoList(editor, options)) return;
    insertBreak();
  };

  return editor;
};